export const DEFAULT_PRIORITY_COLOR = "#2684FF";
export const DEFAULT_PRIORITY_BACKGROUND_COLOR = "#F7FAFF";
export const PRIMARY_BLUE = "#5C5CEB";
export const PRIMARY_OPACITY_90 = "rgba(92, 92, 235, 0.9)";
export const PRIMARY_OPACITY_80 = "rgba(92, 92, 235, 0.8)";
export const PRIMARY_OPACITY_40 = "rgba(92, 92, 235, 0.4)";
export const PRIMARY_OPACITY_20 = "rgba(92, 92, 235, 0.2)";
export const PRIMARY_OPACITY_12 = "rgba(92, 92, 235, 0.12)";
export const PRIMARY_OPACITY_05 = "rgba(92, 92, 235, 0.05)";
export const LIGHT_BLUE_BACKGROUND = "rgba(92, 92, 235, 0.1)";
export const LIGHT_BLUE_CELL = "rgba(217, 218, 247, 1)";
export const MAIN_DARK_PRIMARY = "#212529";
export const LIGHT_GREY_BG ='#F8F9FA';
export const DARK_GREY_TEXT ='#585c68';
export const LIGHT_PURPULE_BACKGROUND ='#F8F8FB';
export const ORGS_RELATED_TO_IDEA_BACKGROUND ='rgba(92, 92, 235, 1)';

